module.exports = __webpack_public_path__ + "static/media/scissors_win.3d3ba694.png";